import styled from 'styled-components';
import { Header } from '@playbookux/playbook-web-core';

export const Main = styled.div`
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 80px;
  max-width: 450px;
  padding-bottom: 10px;
  width: auto;
  padding-bottom: calc(60px + 2%);
  gap: 10px;
`;

export const Title = styled(Header)`
  font-size: 16px;
  font-weight: 400;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  padding: 0 20px;
`;
